import { loadSite, loadWorks, sendOrder, url } from "./api";
import { escapeHtml } from "./render";
import type { Work } from "./types";

export async function initOrder(): Promise<void> {
  const form = document.getElementById("pedido-form") as HTMLFormElement | null;
  const list = document.getElementById("obra-ref");
  const flash = document.getElementById("pedido-flash");
  const extra = document.getElementById("contacto-extra");
  if (!form || !list || !flash) return;

  list.innerHTML = `<p class="form-note">Cargando las piezas…</p>`;

  const [works, site] = await Promise.all([loadWorks(), loadSite()]);
  const chosen = new Set(
    (new URLSearchParams(location.search).get("obra") ?? "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean)
  );

  const paintChecks = (): void => {
    list.innerHTML = works
      .map((work) => {
        const thumb = workThumb(work);
        return `<label class="obra-check">
          <input type="checkbox" name="obras[]" value="${escapeHtml(work.id)}" ${chosen.has(work.id) ? "checked" : ""} />
          ${thumb}
          <span>${escapeHtml(work.title)}</span>
        </label>`;
      })
      .join("");
  };
  paintChecks();

  const bits: string[] = [];
  if (site.whatsapp) {
    bits.push(
      `<a href="https://wa.me/${site.whatsapp}" target="_blank" rel="noreferrer">WhatsApp</a>`
    );
  }
  if (site.instagram) {
    const handle = site.instagram.replace(/^@/, "");
    bits.push(`<a href="https://instagram.com/${handle}" target="_blank" rel="noreferrer">Instagram</a>`);
  }
  if (extra && bits.length) extra.innerHTML = `También por ${bits.join(" o ")}.`;

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const data = new FormData(form);
    const payload: Record<string, string | string[]> = {};
    data.forEach((value, key) => {
      if (key === "obras[]") return;
      payload[key] = String(value);
    });
    payload.obras = data.getAll("obras[]").map(String).filter(Boolean);

    const button = form.querySelector("button[type=submit]") as HTMLButtonElement;
    button.disabled = true;
    flash.innerHTML = "";

    try {
      const result = await sendOrder(payload);
      if (!result.ok) {
        flash.innerHTML = `<p class="flash err">${escapeHtml(result.error || "No se pudo enviar.")}</p>`;
        return;
      }
      form.reset();
      paintChecks();
      flash.innerHTML = `<p class="flash ok">${escapeHtml(result.message || "El encargo llegó.")}</p>`;
    } catch {
      flash.innerHTML = `<p class="flash err">No se pudo enviar. Probá de nuevo en un rato.</p>`;
    } finally {
      button.disabled = false;
    }
  });
}

function workThumb(work: Work): string {
  const image = work.media.find((item) => item.type === "image");
  if (!image) return "";
  return `<img src="${escapeHtml(url(image.src))}" alt="" />`;
}
